// extracted by mini-css-extract-plugin
export var emptyState = "_5i-d";
export var statCard = "_5i-c";
export var table = "_5i-0";
export var tableCell = "_5i-4";
export var tableCellClickable = "_5i-5 _5i-4";
export var tableCellDefault = "_5i-6 _5i-4";
export var tableCellEmpty = "_5i-8";
export var tableCellWithValue = "_5i-7";
export var tableContainer = "_5i-e";
export var tableHeaderWeight = "_5i-1";
export var tableHeaderZone = "_5i-2";
export var tableRowHeader = "_5i-3";
export var viewModeButton = "_5i-9";
export var viewModeButtonActive = "_5i-a _5i-9";
export var viewModeButtonInactive = "_5i-b _5i-9";